import React from 'react';
import { Box } from '@mui/material';
import HeroSection from '../Components/Homepage/HeroSection';
import StatisticsSection from '../Components/Homepage/StatisticsSection';
import ToolsSection from '../Components/Homepage/ToolsSection';
import FadeInSection from '../Components/Homepage/FadeIn';
import ImpactSection from '../Components/Homepage/ImpactSection';

const Home = () => {
  return (
    <>
      {/* Hero Section */}
      <FadeInSection>
      <Box>
          <HeroSection />
        </Box>
      </FadeInSection>

      {/* Floating Impact Section */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 10,
          mt: { xs: -22, md: -18 }, 
        }}
      >
        <ImpactSection />
      </Box>

      {/* Pull Statistics upward to sit behind Impact */}
      <FadeInSection>
      <Box sx={{ mt: { xs: -14, md: -20 } }}>
          <StatisticsSection />
        </Box>
      </FadeInSection>

      {/* Tools Section */}
      <FadeInSection delay={0.3}>
        <ToolsSection />
      </FadeInSection>
    </>
  );
};

export default Home;
